export type VehicleCatalogueMakeModelItem = {
  value: string;
  label: string;
  isCustom?: boolean;
  models: Array<{
    value: string;
    label: string;
    isCustom?: boolean;
    modelGroup?: {
      value: string;
      label: string;
    };
  }>;
};
